import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { BreadcrumbAboutIsn, BannerAbout, RightMenu, ContactUsContent } from '../../common';
import { getLanguage, getQueryString } from '../../../../utils/params';
import { getBanner } from '../../aboutIsn.api';

const ContactUsComponent = () => {
  const { t } = useTranslation();
  const language = getLanguage(useLocation());
  // const [banner, setBanner] = useState({
  //     img: '',
  //     title: ''
  // });

  const breadCrumb = [
    { title: t('about_isn.home'), url: '/' },
    { title: t('about_isn.about_us'), url: '/about-us' },
    { title: t('about_isn.contact_us_menu') },
  ];
  const [banner, setBanner] = useState({
  });
  const data = {
    img: '',
    title: '',
  }

  useEffect(() => {
    getBanner(getQueryString({language, id: 4})).then(res => {
      if(res) {
        data.img = res[0]?.imageUrl
        data.title = t('about_isn.contact_us_menu')
        setBanner(data)
      }
    });
    //eslint-disable-next-line
  }, []);


  useEffect(() => {
    // window.scrollTo(0, 0);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    //eslint-disable-next-line
  }, [language]);

  return (
    <>
      <BreadcrumbAboutIsn breadCrumb={breadCrumb} />
      <section className="group-company">
        <BannerAbout banner={banner} />
        <div id="position-scroll"></div>
        <div className="container mt-5">
          <div className="row">
            <div className="col-12 col-md-9">
              <ContactUsContent />
            </div>
            <div className="col-12 col-md-3">
              <RightMenu />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ContactUsComponent);
